export default __webpack_public_path__ + "/dist/images/image8.22e1ec555b6e29a3f3cca7bf969cd86b.png";